export const faqSectionContent = {
  faqTitleId: 'faqs-title',
  onlyReferFriendFAQs: 'These FAQs are about our referrals scheme only.',
  viewFAQsOnNetwork: 'View FAQs about our network.',
}
